// extracted by mini-css-extract-plugin
export default {"Card":"TeamCard_Card__ZPrLN","FeaturedContent":"TeamCard_FeaturedContent__vHulv","LogoContainer":"TeamCard_LogoContainer__EjqO7","LogoImage":"TeamCard_LogoImage__J6sDp"};